<template>
    <div>
        <brand-logo class="flex items-center justify-start" />
        <div class="flex justify-end" v-if="!$configs.inIframe">
            <nav-user-dropdown />
        </div>
    </div>
</template>

<script>
    import BrandLogo from '@/components/BrandLogo.vue';
    import NavUserDropdown from '@/components/Navs/NavUserDropdown.vue';

    export default {
        components: {
            BrandLogo,
            NavUserDropdown,
        },
    };
</script>
